import { defineComponent, onBeforeMount, ref } from '@vue/composition-api';
import { judgeOffline } from '@/pages/center/fission/utils';
import FissionInvitees from './index.vue';
import { logger } from '@/utils/logger';
export default defineComponent({
  components: {
    FissionInvitees: FissionInvitees
  },
  setup: function setup() {
    var show = ref(false);
    onBeforeMount(function () {
      var bucket = new URL(window.location.href).searchParams.get('shareBucket') || new URL(window.location.href).searchParams.get('share_bucket') || '';

      if (judgeOffline(bucket)) {
        logger.kwailog.sendPv({
          page: 'CREATOR_SCOUT_INVITED_H5'
        });
        show.value = true;
      }
    });
    return {
      show: show
    };
  }
});